import * as React from 'react';

import { Cross } from 'recharts';

type HeadsetSvgProps = React.SVGProps<SVGSVGElement> & {
  width?: number;
  height?: number;
};

const CrossSvg: React.FC<HeadsetSvgProps> = ({ width = 14, height = 14, ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none" viewBox="0 0 14 14" {...props}>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.4339 6.60316L6.71677 0.885998L7.28245 0.320312L13.9653 7.00316L7.28245 13.686L6.71677 13.1203L12.4339 7.40316H0.599609V6.60316H12.4339Z"
      fill="white"
    />
  </svg>
);
export default CrossSvg;
